import React from 'react';
import InputMask from 'react-input-mask';
import FileBase64 from 'react-file-base64';
import { InputPassword } from '~/components/FieldPassword';
import { InputPhoneMask } from '~/components/FieldPhone';
import { PasswordInformation } from '~/components/PasswordInformation';
import { UNIDADES_FEDERATIVAS } from '~/util/domainutils';
import { formatCpfCnpj } from '~/util/stringutils';
import * as S from './styles';

function FormEmployee(params) {
  const {
    handleSubmit,
    person,
    errors,
    imageName,
    resale,
    password,
    confirmPassword,
    handleInputNomeSocialChange,
    handleInputTelefone1Change,
    handleInputTelefone2Change,
    handleSelectEstadoChange,
    handleInputCidadeChange,
    handleInputCepChange,
    handleInputEnderecoChange,
    handleInputBairroChange,
    handleInputPontoReferenciaChange,
    handleInputComplementoChange,
    setInputImagem,
    handleInputPasswordChange,
    handleInputConfirmPasswordChange,
  } = params;

  return (
    <form onSubmit={handleSubmit}>
      <S.ContainerContent>
        <label id='title'>Dados Gerais</label>
        <div className="rowContainer">
          <div className="inputHolder defaultFlex">
            <span>Revenda</span>
            <input
              type="text"
              name="revenda"
              disabled
              defaultValue={resale.nomeFantasia}
            />
          </div>
          <div className="inputHolder defaultFlex">
            <span>CPF</span>
            <input
              type="text"
              name="cpfCnpj"
              disabled
              defaultValue={formatCpfCnpj(resale.cpfCnpj)}
            />
          </div>
          <div className="inputHolder defaultFlex noMarginRight">
            <span>Email</span>
            <input
              type="text"
              name="email"
              disabled
              defaultValue={resale.email}
            />
          </div>
        </div>
        <div className="rowContainer">
          <div className="inputHolder defaultFlex">
            <span>Nome Completo *</span>
            <input
              type="text"
              name="nomeCompleto"
              value={person.nomeSocial}
              onChange={handleInputNomeSocialChange}
            />
            {errors.errorNomeSocial && (
              <small style={{ color: 'red' }}>
                Campo obrigatório
              </small>
            )}
          </div>
          <div className="inputHolder">
            <span>Telefone (1)</span>
            <InputPhoneMask
              type="text"
              name="telefone1"
              value={person.telefone1}
              onChange={handleInputTelefone1Change}
            />
          </div>
          <div className="inputHolder noMarginRight">
            <span>Telefone (2)</span>
            <InputPhoneMask
              type="text"
              name="telefone2"
              value={person.telefone2}
              onChange={handleInputTelefone2Change}
            />
          </div>
        </div>
      </S.ContainerContent>
      <S.ContainerContent>
        <label id='title'>Endereço</label>
        <div className="rowContainer">
          <div className="inputHolder">
            <span>Estado</span>
            <select
              name="estado"
              value={person.estado}
              onChange={handleSelectEstadoChange}
            >
              <option value={''}>Selecione</option>
              {UNIDADES_FEDERATIVAS.map(uf => (
                <option key={uf.sigla} value={uf.nome}>
                  {uf.nome}
                </option>
              ))}
            </select>
          </div>
          <div className="inputHolder defaultFlex">
            <span>Cidade</span>
            <input
              type="text"
              name="cidade"
              value={person.cidade}
              onChange={handleInputCidadeChange}
            />
          </div>
          <div className="inputHolder noMarginRight">
            <span>CEP</span>
            <InputMask
              mask="99.999-999"
              name="cep"
              value={person.cep}
              onChange={handleInputCepChange}
            />
          </div>
        </div>
        <div className="rowContainer">
          <div className="inputHolder defaultFlex">
            <span>Endereço Completo</span>
            <input
              type="text"
              name="endereco"
              value={person.endereco}
              onChange={handleInputEnderecoChange}
            />
          </div>
          <div className="inputHolder defaultFlex noMarginRight">
            <span>Bairro</span>
            <input
              type="text"
              name="bairro"
              value={person.bairro}
              onChange={handleInputBairroChange}
            />
          </div>
        </div>
        <div className="rowContainer">
          <div className="inputHolder defaultFlex">
            <span>Ponto de Referência</span>
            <input
              type="text"
              name="pontoReferencia"
              value={person.pontoReferencia}
              onChange={handleInputPontoReferenciaChange}
            />
          </div>
          <div className="inputHolder defaultFlex noMarginRight">
            <span>Complemento</span>
            <input
              type="text"
              name="complemento"
              value={person.complemento}
              onChange={handleInputComplementoChange}
            />
          </div>
        </div>
      </S.ContainerContent>
      <S.ContainerContent>
        <S.ImageContainer>
          <S.ImageContent>
            <label id='title'>Foto do(a) Colaborador(a)</label>
            <div className="imagePicker">
              <div className="buttonHolder">
                <span>ESCOLHER IMAGEM</span>
                <FileBase64
                  multiple={false}
                  onDone={setInputImagem.bind(this)}
                />
              </div>
              <label>{imageName || 'Selecione um arquivo de imagem'}</label>
            </div>
          </S.ImageContent>
        </S.ImageContainer>
      </S.ContainerContent>
      <S.ContainerContent>
        <label id='title'>Segurança</label>
        <div className="rowContainer">
          <div className="inputHolder defaultFlex">
            <span>Senha *</span>
            <InputPassword
              autoComplete="new-password"
              type="password"
              name="password"
              value={password}
              onChange={handleInputPasswordChange}
            />
            {errors.errorSenha && (
              <small style={{ color: 'red' }}>
                Campo obrigatório
              </small>
            )}
          </div>
          <div className="inputHolder defaultFlex noMarginRight">
            <span>Confirmar senha *</span>
            <InputPassword
              autoComplete="new-confirm-password"
              type="password"
              name="confirmPassword"
              value={confirmPassword}
              onChange={handleInputConfirmPasswordChange}
            />
            {errors.errorConfirmarSenha && (
              <small style={{ color: 'red' }}>
                Campo obrigatório
              </small>
            )}
          </div>
        </div>

        <PasswordInformation password={password} />
      </S.ContainerContent>
    </form>
  );
}

export { FormEmployee };
